(() => {
  const MOBILE_QUERY = '(max-width: 749px)';
  const SWIPE_THRESHOLD = 44;
  const HORIZONTAL_INTENT_RATIO = 1.2;

  const initialiseGallery = (gallery) => {
    const slider = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (!slider || slider.dataset.shSwipeReady === 'true') return;

    const slides = () => [...slider.querySelectorAll('.product__media-item')].filter((slide) => slide.offsetWidth > 0);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia(MOBILE_QUERY);
    let pointerStart = null;
    let swiped = false;

    slider.dataset.shSwipeReady = 'true';

    const nearestIndex = () => {
      const items = slides();
      if (!items.length) return 0;

      return items.reduce((nearest, slide, index) => {
        const currentDistance = Math.abs(slider.scrollLeft - slide.offsetLeft);
        const nearestDistance = Math.abs(slider.scrollLeft - items[nearest].offsetLeft);
        return currentDistance < nearestDistance ? index : nearest;
      }, 0);
    };

    const moveTo = (index, behavior = reducedMotion.matches ? 'auto' : 'smooth') => {
      const items = slides();
      if (!items.length) return;

      const boundedIndex = Math.max(0, Math.min(index, items.length - 1));
      const target = items[boundedIndex].offsetLeft;

      if (behavior === 'auto') {
        slider.scrollLeft = target;
        return;
      }

      slider.scrollTo({ left: target, behavior });
    };

    slider.addEventListener('pointerdown', (event) => {
      if (!mobile.matches || event.button > 0 || !event.isPrimary) return;

      const activeIndex = nearestIndex();
      moveTo(activeIndex, 'auto');
      pointerStart = { x: event.clientX, y: event.clientY, index: activeIndex };
      swiped = false;
    });

    slider.addEventListener('pointerup', (event) => {
      if (!mobile.matches || !pointerStart || !event.isPrimary) return;

      const deltaX = event.clientX - pointerStart.x;
      const deltaY = event.clientY - pointerStart.y;
      const horizontalIntent = Math.abs(deltaX) >= SWIPE_THRESHOLD
        && Math.abs(deltaX) > Math.abs(deltaY) * HORIZONTAL_INTENT_RATIO;

      if (horizontalIntent) {
        swiped = true;
        moveTo(pointerStart.index + (deltaX < 0 ? 1 : -1));
        window.setTimeout(() => { swiped = false; }, 500);
      } else {
        moveTo(pointerStart.index);
      }

      pointerStart = null;
    });

    slider.addEventListener('pointercancel', () => {
      if (pointerStart) moveTo(pointerStart.index);
      pointerStart = null;
    });

    slider.addEventListener('click', (event) => {
      if (!swiped) return;
      event.preventDefault();
      event.stopPropagation();
      swiped = false;
    }, true);

    const keepCurrentSlideAligned = () => {
      if (!mobile.matches) return;
      moveTo(nearestIndex(), 'auto');
    };

    mobile.addEventListener('change', keepCurrentSlideAligned);
    new ResizeObserver(keepCurrentSlideAligned).observe(slider);
  };

  const initialiseProductGalleries = () => {
    document.querySelectorAll('media-gallery').forEach(initialiseGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseProductGalleries, { once: true });
  } else {
    initialiseProductGalleries();
  }

  document.addEventListener('shopify:section:load', initialiseProductGalleries);
})();
